import { api } from '../api';
import {
  TestSuiteInfo,
  TestExecutionRequest,
  TestSuiteDetail,
  TestSuiteVersion,
  UpdateTestSuiteScheduleRequest,
} from '../interfaces/TestSuite.types';

export const urlTestSuite = 'tests/testSuites';

export const testSuiteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTestSuites: builder.query<TestSuiteInfo[], void>({
      query: () => ({
        url: `${urlTestSuite}`,
        method: 'GET',
      }),
      providesTags: ['TestSuite'],
    }),

    runTestSuite: builder.mutation<void, TestExecutionRequest>({
      query: (data) => ({
        url: `${urlTestSuite}/run`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['TestSuite']
    }),

    uploadTestSuite: builder.mutation<void, any>({
      query: (data) => ({
        url: `${urlTestSuite}/upload`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['TestSuite'], // Invalidate ALL TestSuite related caches
    }),

    getTestSuiteDetail: builder.query<TestSuiteDetail, string>({
      query: (testSuiteId) => ({
        url: `${urlTestSuite}/${testSuiteId}`,
        method: 'GET',
      }),
      providesTags: (result, error, testSuiteId) => [
        'TestSuite', // This matches the invalidatesTags in uploadTestSuite
        { type: 'TestSuite', id: testSuiteId },
        { type: 'TestSuite', id: 'DETAIL' }
      ],
    }),

    getTestSuiteVersion: builder.query<TestSuiteVersion, { testSuiteId: string; versionId: string }>({
      query: ({ testSuiteId, versionId }) => ({
        url: `${urlTestSuite}/${testSuiteId}/versions/${versionId}`,
        method: 'GET',
      }),
      providesTags: ['TestSuite'],
    }),

    updateTestSuiteSchedule: builder.mutation<void, UpdateTestSuiteScheduleRequest>({
      query: ({ testSuiteId, isScheduled }) => ({
        url: `${urlTestSuite}/${testSuiteId}/schedule`,
        method: 'PATCH',
        body: { isScheduled },
      }),
      invalidatesTags: ['TestSuite'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTestSuitesQuery,
  useRunTestSuiteMutation,
  useUploadTestSuiteMutation,
  useGetTestSuiteDetailQuery,
  useLazyGetTestSuiteVersionQuery,
  useUpdateTestSuiteScheduleMutation,
} = testSuiteApi;
